import { SemTest } from '@/store/store'

const initState = {
    uuidInfo: '', // 用户唯一标识，uuid
    semTestPlan:'', // 记录进入的是b方案（值为1）还是c方案（值为2），
    semtestBannerForm: true, // banner右侧form表单,abTest中的b方案
}
const mutations = {
    setUuidInfo(state: SemTest, payload: any) {
        state.uuidInfo = payload
    },
    setSemTestPlan(state: SemTest, payload: any) {
        state.semTestPlan = payload
    },
    setSemtestBnnnerForm(state: SemTest, payload: any) {
        state.semtestBannerForm = payload
    }
}

export default {
    namespaced: true,
    state: initState,
    mutations,
}
